// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2LZd0","modalForm":"UpgradeEpcsModal_modalForm__1E1o2","modalFooter":"UpgradeEpcsModal_modalFooter__2P34G"};